import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-frame border-primary-50" }
const _hoisted_2 = { class: "panel-frame-header" }
const _hoisted_3 = { class: "h3 mb-s6" }
const _hoisted_4 = { class: "panel-frame-close-icon" }
const _hoisted_5 = { class: "mr-s1" }

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { STEP_STATUS, StepInfo } from '@/components/stepper/stepper.types';
import Step from '@/components/stepper/Step.vue';
import Icon from '@/components/icon/Icon.vue';
import { computed } from 'vue';
import ControlIcon from '@/components/icon/ControlIcon.vue';
import { FarmingAction } from '@/store/modules/farming/models/farming-action';
import { useFarmingSteps } from '@/store/modules/farming/useFarmingSteps';
import { useFarmingStake } from '@/store/modules/farming/stake/useFarmingStake';
import { useFarmingUnstake } from '@/store/modules/farming/unstake/useFarmingUnstake';
import { useFarmingHarvest } from '@/store/modules/farming/harvest/useFarmingHarvest';


export default /*#__PURE__*/_defineComponent({
  __name: 'FarmingSteps',
  props: {
    action: null
  },
  emits: ["onClose"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onClose'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  action: string;
}





const { t, te } = useI18n();
const { state } = useStore();
const { farmingSteps, $reset } = useFarmingSteps();
const { farmingStakeForm } = useFarmingStake();
const { farmingUnstakeForm } = useFarmingUnstake();
const { farmingHarvestForm } = useFarmingHarvest();

const farmingFormByAction: Record<FarmingAction, Pick<typeof farmingStakeForm, 'farm'>> = {
  stake: farmingStakeForm,
  unstake: farmingUnstakeForm,
  harvest: farmingHarvestForm,
};

const farmingForm = computed(() => farmingFormByAction[farmingSteps.action ?? 'stake']);

const header = computed(() =>
  t(`farming.steps.header.${props.action}`, {
    farmName: farmingForm.value.farm?.portfolio.name,
  }),
);

const isError = computed(() =>
  farmingSteps.steps.some((step: StepInfo) => step.status === STEP_STATUS.ERROR),
);

const isSuccessful = computed(() =>
  farmingSteps.steps.every((step: StepInfo) => step.status === STEP_STATUS.SUCCESS),
);

const infoMessage = computed(() => {
  const currentActiveIndx = farmingSteps.steps.findIndex(
    step => step.status === STEP_STATUS.ACTIVE,
  );
  const msgType = farmingSteps.steps[currentActiveIndx]?.type ?? 'default';

  return te(`farming.steps.infoMessage.${msgType}`)
    ? t(`farming.steps.infoMessage.${msgType}`)
    : t(`wrappedContract.steps.infoMessage.${msgType}`);
});

const onCloseSteps = () => {
  $reset();
  emits('onClose');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(header)), 1),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isError) || _unref(isSuccessful))
            ? (_openBlock(), _createBlock(ControlIcon, {
                key: 0,
                name: "close",
                onClick: onCloseSteps
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex p-s3 mb-s3", _unref(isError) ? 'panel-message-error' : 'panel-message-info'])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Icon, {
            name: "error",
            size: "16"
          })
        ]),
        _createElementVNode("div", null, _toDisplayString(_unref(isError) ? _unref(t)('wrappedContract.steps.infoMessage.error') : _unref(infoMessage)), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["steps", _unref(state).layout.isMobile ? 'steps-column' : 'steps-row'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(farmingSteps).steps, (step, index) => {
          return (_openBlock(), _createBlock(Step, {
            key: props.action + index,
            number: index + 1,
            name: step.name!,
            status: step.status
          }, null, 8, ["number", "name", "status"]))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})